/*-----------------------------------------------------------------
- Footer
-----------------------------------------------------------------*/
export default {
    title      : 'یسناشاپ ، آشنای خانواده',
    description:
        `لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و 
        با استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است 
        و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد`,
    menu_title      : 'یسناشاپ',
    contact_title   : 'راه‌های ارتباطی با ما',
    socials_title   : 'ما را در شبکه‌های اجتماعی دنبال کنید',
    trust_seal_title: 'با خیال راحت به ما اعتماد کنید',
    copy_right_text : 'کلیه حقوق این سایت و مطالب آن برای یسناشاپ است.',
    powered_by_text : 'قدرت گرفته از کوارکینو',
};
